import type { ExcludedOffering } from "../types";

export interface ExclusionSummary {
  code: string;
  detail: string;
  count: number;
}

/**
 * Agrupa los motivos de exclusión por código para explicar un resultado vacío
 * sin duplicar la lista completa (ISS-695/696). El detalle es el primero
 * observado para el código; el conteo indica cuántas ofertas lo comparten.
 */
export function summarizeExclusions(
  excluded: ExcludedOffering[] | undefined,
  limit = 5,
): ExclusionSummary[] {
  const byCode = new Map<string, ExclusionSummary>();
  for (const entry of excluded ?? []) {
    for (const reason of entry.reasons ?? []) {
      const current = byCode.get(reason.code);
      if (current) {
        current.count += 1;
      } else {
        byCode.set(reason.code, {
          code: reason.code,
          detail: reason.detail,
          count: 1,
        });
      }
    }
  }
  return [...byCode.values()]
    .sort((a, b) => b.count - a.count || a.code.localeCompare(b.code))
    .slice(0, limit);
}
